<template>
  <div id="app">
    <!--    <div style="height: 100%;" v-if="$route.meta.noPubComp">-->
    <!--      <keep-alive :include="include">-->
    <!--        <router-view v-if="$route.meta.keepAlive"></router-view>-->
    <!--      </keep-alive>-->
    <!--      <router-view v-if="!$route.meta.keepAlive"></router-view>-->
    <!--    </div>-->
    <!--    <div v-else style="height: 100%;display: flex;">-->
    <!--      <div style="height: 100%;width: 200px;">-->
    <!--        <left-slide />-->
    <!--      </div>-->
    <!--      <div-->
    <!--        style="display: flex;flex-direction: column;width: calc(100% - 200px);overflow-y:auto;"-->
    <!--      >-->
    <!--        <div style="height: 50px;background-color: white;width: 100%">-->
    <!--          <self-header></self-header>-->
    <!--        </div>-->
    <!--        <div class="app-main">-->
    <!--          <div class="container">-->
    <!--            <Header />-->
    <!--            <router-view/>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--      </div>-->

    <!--    </div>-->
    <my-header v-if="!$route.meta.hideHeader"></my-header>
    <keep-alive :include="include">
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="'柠檬网联-'+$route.meta.title"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="'柠檬网联-'+$route.meta.title"></router-view>
    <my-footer v-if="!$route.meta.hideFooter"></my-footer>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      include: ['news'] //第一次直接进入watch route没有监听到，所以手动赋初始值
    };
  },
  watch: {
    $route(to, from) {
      // console.log('to====',to.meta.name,to.meta.deepth)
      // console.log('from====',from.meta.name,from.meta.deepth)

      //如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name);
      }
      //如果 要 form(离开) 的页面是 keepAlive缓存的，
      //再根据 deepth 来判断是前进还是后退
      //如果是后退
      if (
        from.meta.keepAlive &&
        (to.meta.deepth || 0) <= (from.meta.deepth || 0)
      ) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }
    }
  },
  methods: {}
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  /*min-width: 1350px!important;*/
  background: #ffffff;
  margin: 0;
  padding: 0;
}
html,
body {
  font-size: 12px; /* 设置基准字体大小为 16px */
}

.cus-pointer {
  cursor: pointer;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(50%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-50%);
  }
}
@keyframes moveIcon {
  0% {
    left: 0;
  }
  50% {
    left: 0.1rem; /* 向右移动100px */
  }
  100% {
    left: 0;
  }
}
.durationTime{
  animation-duration: 1.5s !important;
}
.background-fill {
  width: 200px; /* 设置div的宽度 */
  height: 200px; /* 设置div的高度 */
  position: relative;
  overflow: hidden;
}

.background-fill::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: #FEF100;
  transition: height 0.5s; /* 使用过渡效果实现平滑动画 */
  z-index: -1; /* 将背景设置在最底层 */
  clip-path: polygon(0 0, calc(100% - 0.08rem) 0%, 100% 0.08rem, 100% 100%, 0.08rem 100%, 0% calc(100% - 0.08rem));
}

.background-fill:hover::before {
  height: 100%; /* 鼠标悬停时改变高度，触发背景填充效果 */
}
.main-color{
  color: #fef100;
}
.disabled-cursor:hover {
  cursor: not-allowed; /* 在悬停时改变鼠标样式为禁止符号 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue